import _ from 'lodash';
import localizedCountries from 'localized-countries';

import dataDe from 'localized-countries/data/de';
import dataEn from 'localized-countries/data/en';
import dataEs from 'localized-countries/data/es';
import dataFi from 'localized-countries/data/fi';
import dataSl from 'localized-countries/data/sl';
import dataRo from 'localized-countries/data/ro';
import dataFr from 'localized-countries/data/fr';

import parentConfig from 'config';

export default {
  ...parentConfig,

  customerSupport: {
    email: 'support@propnow.com',
    phone: '+49 30 959992518',
  },

  localeCodes: ['de-DE'],

  buyerTypes: ['private', 'company'],

  ownershipTypes: ['sole', 'joint', 'share'],

  maritalStatuses: ['none', 'single', 'married'],

  companyLegalForms: [
    'simple_society',
    'general_partnership',
    'limited_partnership',
    'joint-stock_company',
    'kommandit-aktiengesellschaft',
    'limited_liability_company',
    'cooperative',
    'society',
    'foundation',
    'other',
  ],

  documentTypes: [
    'annual_statement',
    'appraisal',
    'area_allocation_plan',
    'area_measurement',
    'building_permit',
    'easement_register',
    'energy_certificate',
    'expose',
    'insurance_policy',
    'land_register',
    'location_map',
    'partition_deed',
    'partition_plan',
    'rental_contract',
    'reserves',
    'utility_costs',
    'other',
  ],

  uploadTypes: ['identity_document', 'proof_of_financial_resources'],
  defaultUploadTypes: [],
  requiredUploadTypes: [],

  titleTypes: ['doctor', 'professor'],

  provisionTypes: ['none', 'fixed_amount', 'fixed_percentage'],
  defaultProvisionType: 'none',

  depositTypes: ['none', 'percentage'],

  provision_percentage_max: 100,
  deposit_percentage_max: 10,

  handoverTypes: [
    'land_register',
    'money_transfer',
    'key_handover',
    'sale_contract',
  ],

  privateSellers: ['private', 'privat-bieterportal', 'bvbi'],
  disableRightOfWithdrawal: ['wuestenrot'],
  disableSaleToC: ['kski'],
  hideKnownDefects: ['kski'],

  defaultSaleOfferData: {},

  mlsTypes: ['none', 'tenant', 'everyone'],

  roundTypes: ['incremental_auction', 'sealed_bidding', 'simple_offer'],
  // roundTypeBadges: {
  //   incremental_auction: ['new'],
  //   simple_offer: ['new', 'free'],
  // },

  saleCountryOverride: {
    de: {
      handoverTypes: [
        'land_register',
        'money_transfer',
        'key_handover',
        'sale_contract',
      ],

      defaultSaleOfferData: {
        handover: 'sale_contract',
      },
    },
    ch: {
      currency: { code: 'CHF', symbol: 'CHF' },
      localeCodes: ['de-CH', 'fr-CH', 'it-CH', 'en'],
      uploadTypes: [
        'identity_document',
        'residence_permit',
        'proof_of_financial_resources',
      ],
      ownershipTypes: ['ae', 'ge', 'meg', 'stwe'],
      defaultProvisionType: 'none',
      depositTypes: ['none', 'fixed_amount', 'percentage'],
      swissResidentialStatuses: [
        'B',
        'C',
        'Ci',
        'G',
        'L',
        'F',
        'N',
        'S',
        'none',
      ],
      martialStatuses: ['none', 'single', 'married', 'divorced', 'widowed'],
    },
    si: {
      currency: { code: 'EUR', symbol: 'EUR' },
      localeCodes: ['sl-SI'],
      uploadTypes: [
        'identity_document',
        'proof_of_financial_resources',
        'confirmation_of_payment_reservation',
      ],
      mlsTypes: ['none'],
      depositTypes: ['none', 'fixed_amount', 'percentage'],
      defaultProvisionType: 'none',
      companyLegalForms: [
        'limited_liability_company',
        'unlimited_liability_company',
        'self_employed',
        'jointstock_company',
        'kommanditaktiengesellschaft',
        'foundation',
        'other',
      ],
    },
    at: {
      localeCodes: ['de-AT', 'en'],
      ownershipTypes: ['sole', 'joint', 'partnership', 'share', 'condominium'],

      provisionTypes: [
        'none',
        'standard_at',
        'fixed_amount',
        'fixed_percentage',
      ],
      defaultProvisionType: 'standard_at',
      allowConditionsInRounds: ['incremental_auction', 'simple_offer'],
    },
    gb: {
      currency: { code: 'GBP', symbol: '£' },
      roundHideValidity: true,
      localeCodes: ['en-GB'],
      saleEditTotalPages: 2,
      defaultUploadTypes: [],
      documentTypes: ['expose', 'energy_certificate'],
      salePropertyTypes: [
        'house',
        'flat',
        'property',
        'office',
        'business',
        'other',
      ],
      defaultSaleOfferData: {
        timezone: 'Europe/London',
      },
    },
    fi: {
      roundTypes: ['open_bidding', 'sealed_bidding'],
      salePropertyTypes: ['flat'],
      localeCodes: ['fi-FI', 'en'],
      defaultSaleOfferData: {
        timezone: 'Europe/Helsinki',
      },
      paymentTypes: ['none', 'deposit', 'penalty'],
      depositTypes: ['none', 'fixed_amount', 'percentage'],
      penaltyTypes: ['none', 'fixed_amount', 'percentage'],
      handoverTypes: ['land_register', 'money_transfer'],
      documentTypes: [
        'brochure',
        'real_estate_managers_certificate',
        'share_based_dwelling_printout',
        'share_register_printout',
        'financial_statements',
        'articles_of_association',
        'floor_plan',
        'moisture_measurement_and_condition_audit_reports',
        'condition_of_the_building_report',
        'maintenance_needs_report',
        'long_term_repair_plan',
        'maintenance_plan',
        'energy_performance_certificate',
        'repairs_and_alterations_report',
        'lease',
        'floor_area_measurement_record',
        'certificate_of_title',
        'encumbrance_certificate',
        'cadastral_certificate',
      ],
    },
    it: {
      customerSupport: {
        email: 'sales@propnow.com',
        phone: '+39 02 3858 5482',
      },

      // roundTypes: ['open_bidding', 'sealed_bidding'],

      localeCodes: ['it-IT', 'en', 'de'],

      buyerTypes: ['private', 'company', 'entrepreneur'],

      sellerTypes: ['private', 'company', 'entrepreneur'],

      usageTypes: [
        'residential',
        'commercial',
        'industrial',
        'service',
        'tourist',
      ],

      objectProvenanceTypes: ['sale', 'donation', 'succession', 'other'],
      objectProvenanceTypesWithDetails: ['sale', 'donation', 'succession'],

      cadastralComplianceTypes: ['compliant', 'noncompliant_fixed'],
      regulationComplianceTypes: ['guaranteed', 'not_guaranteed'],

      occupationTypes: ['free', 'rented'],
      debtTypes: ['none', 'mortgage', 'lien', 'judical_claim', 'forclosure'],

      documentTypes: [
        'expose',
        'origin_deed',
        'cadastral_survey',
        'cadastral_plan',
        'energy_certificate',
      ],

      depositTypes: ['none', 'fixed_amount'],

      uploadTypes: ['identity_document', 'proof_of_financial_resources'],
      defaultUploadTypes: [],
      requiredUploadTypes: [],

      defaultSaleOfferData: {
        due_diligence_deadline_days: 7,
        deposit_type: 'fixed_amount',
        deposit_transfer_owner: 'Parte Venditrice',
      },
    },
    za: {
      currency: { code: 'ZAR' },
      localeCodes: ['en-ZA'],
      sellerTypes: ['private', 'company'],
      depositTypes: ['none', 'fixed_amount', 'percentage'],
      handoverTypes: ['transfer'],
      salutationTypes: ['mr', 'mrs', 'ms', 'miss'],

      timezone: 'Africa/Johannesburg',

      defaultSaleOfferData: {
        timezone: 'Africa/Johannesburg',
      },
      offerData: {
        onUpdate: {
          offer_variant: {
            residential: { offer_template_version: 'v8' },
            commercial: { offer_template_version: 'v6' },
          },
        },
      },
      documentTypes: [
        'brochure',
        'property_condition_report',
        'tenancy_overview',
      ],
      defaultUploadTypes: [],
      // proof of funds is preselected for commercial OTPs only
      getDefaultUploadTypes(offerData) {
        return offerData.offer_variant === 'commercial'
          ? ['proof_of_financial_resources']
          : [];
      },
      certificateTypes: [
        'electrical_compliance_certificate',
        'gas_installation',
        'electrical_fence_certificate',
        'beetle_certificate',
        'water_certificate',
        'plumbing_certificate',
        'alien_and_invasive_species_regulations',
      ],
      getRequiredDocumentTypes(sale, offerData) {
        const types = ['property_condition_report'];
        if (
          offerData.offer_variant === 'commercial' &&
          offerData.occupation === 'multi_tenancies'
        ) {
          types.push('tenancy_overview');
        }
        return types;
      },
    },
    es: {
      localeCodes: ['es-ES', 'de', 'en'],

      buyerTypes: ['private', 'company'],

      sellerTypes: ['private', 'company'],

      usageTypes: [
        'residential',
        'commercial',
        'industrial',
        'service',
        'tourist',
      ],
      debtTypes: ['', 'mortgage', 'lien', 'judical_claim', 'foreclosure'],

      uploadTypes: ['identity_document', 'proof_of_financial_resources'],
      defaultUploadTypes: [],
      requiredUploadTypes: [],

      defaultSaleOfferData: {
        signing_deadline_days: 10,
        closing_seller_target_days: 60,
        closing_seller_deadline_days: 60,
        deposit_type: 'fixed_amount',
        security_type: 'percentage',
        security_percentage: 10,
        costs_deed: 'law',
        timezone: 'Europe/Madrid',
      },

      sellerIdTypes: ['dni', 'nie', 'nif', 'personal_id', 'passport'],

      objectProvenanceTypes: [
        'sale',
        'donation',
        'succession',
        'awarding',
        'other',
      ],

      depositTypes: ['none', 'fixed_amount'],

      securityTypes: ['none', 'percentage'],
    },
    vi: {
      timezone: 'America/Virgin',

      deedTypes: ['warranty', 'special_warranty', 'quitclaim'],
      tenancyTypes: ['free', 'occupied'],
      salutationTypes: ['mr', 'mrs', 'ms', 'miss'],

      localeCodes: ['en-US'],

      currency: { code: 'USD' },

      defaultSaleOfferData: {
        timezone: 'America/Virgin',

        agent_representing: true,

        closing_location: 'St. Thomas',
      },

      agentRegistrationDefaultTenant: 'propnow-vi',
    },
    pr: {
      saleEditTotalPages: 2,

      timezone: 'America/Puerto_Rico',
      localeCodes: ['en-PR'],
      currency: { code: 'USD' },

      defaultSaleOfferData: {
        timezone: 'America/Puerto_Rico',
      },
    },
    bs: {
      saleEditTotalPages: 2,

      timezone: 'America/Nassau',
      localeCodes: ['en-BS'],
      currency: { code: 'USD' },

      defaultSaleOfferData: {
        timezone: 'America/Nassau',
      },
    },
    ro: {
      localeCodes: ['ro-RO'],
      buyerTypes: ['private', 'company'],
      ownershipTypes: ['sole', 'share'],
      documentTypes: [
        'commercial_register_proof',
        'proof_of_ownership',
        'ownership_deed',
        'property_sketch',
        'energy_certificate',
        'land_register',
        'photo',
        'seller_statements',
        'location_map',
        'building_permit',
        'technical_documentation',
        'cadastral_documentation',
        'cadastral_plan',
        'area_allocation_plan',
        'lease_agreement',
        'other',
      ],
      uploadTypes: ['identity_document'],
      defaultUploadTypes: ['identity_document'],
      requiredUploadTypes: ['identity_document'],
      objectConstructionTypes: [
        'concrete',
        'brick',
        'bca',
        'wood',
        'metal',
        'frame',
        'plates',
        'monolith',
        'other',
      ],
      sellerTypes: ['private', 'company'],
      provisionTypes: ['none', 'fixed_amount', 'fixed_percentage'],
      saleCurrencies: ['EUR'],
      maritalStatuses: ['none', 'single', 'married'],
      prenuptialAgreementValues: ['yes', 'no'],
      idDocumentTypes: ['national_id', 'passport'],
      vatValues: [5, 19],

      getRequiredDocumentTypes(sale, offerData) {
        let result = {};
        if (offerData.object_type === 'property')
          result['property'] = [
            'ownership_deed',
            'property_sketch',
            'land_register',
          ];
        else
          result['property'] = [
            'ownership_deed',
            'property_sketch',
            'energy_certificate',
            'land_register',
          ];
        return result;
      },

      getRegistrationScheme(sale, t) {
        let scheme = parentConfig.getRegistrationScheme.call(this, sale, t);
        delete scheme.title;
        if (
          sale.offerData.deposit_type &&
          sale.offerData.deposit_type !== 'none'
        ) {
          scheme.depositRequired = {
            type: 'dropdown',
            options: [true, false],
            required: true,
            target: ['offerData.deposit_type'],
            transform: (value) => {
              if (value)
                return sale.offerData && sale.offerData.deposit_type
                  ? sale.offerData.deposit_type
                  : 'fixed_amount';
              else return 'none';
            },
          };
        }
        return scheme;
      },
    },
    lu: {
      customerSupport: {
        email: 'support@propnow.com',
        phone: '+49 30 959992518',
      },
      localeCodes: ['fr-LU'],
      roundDefaultDurationInDays: 3,
      durationTypes: ['fixed'],
      buyerTypes: ['private', 'company'],
      sellerTypes: ['private', 'company'],
      ownershipTypes: ['sole', 'joint', 'share'],
      depositTypes: ['none', 'fixed_amount'],
      companyLegalForms: [
        'simple_society',
        'general_partnership',
        'limited_partnership',
        'joint-stock_company',
        'kommandit-aktiengesellschaft',
        'limited_liability_company',
        'cooperative',
        'society',
        'foundation',
        'other',
      ],
      handoverTypes: ['key_handover', 'contract'],
      documentTypes: [
        'expose',
        'land_register',
        'building_permit',
        'energy_certificate',
        'appraisal',
        'promissory_note',
      ],
      uploadTypes: ['identity_document', 'proof_of_financial_resources'],
      defaultUploadTypes: [],
      requiredUploadTypes: [],
      saleActions: [
        'award',
        'confirmAward',
        'counteroffer',
        'increase',
        'rejectAll',
        'duplicate',
        'notifySeller',
      ],
      mlsTypes: ['everyone'],
      getRegistrationScheme(sale, t) {
        let scheme = parentConfig.getRegistrationScheme.call(this, sale, t);
        delete scheme.title;
        return scheme;
      },
      roundTypes: ['sealed_bidding', 'counteroffer_bidding'],
      allowConditionsInRounds: ['sealed_bidding', 'counteroffer_bidding'],
      getRoundTypes: (store) => {
        if (store.round && store.round.status === 'closed') {
          return ['sealed_bidding', 'counteroffer_bidding'];
        }
        return ['sealed_bidding'];
      },
    },
  },

  saleCommands: [
    'whitelisting',
    'edit',
    'preview',
    'previewPdf',
    'delete',
    'close',
    'overview',
    'download',
    'manage',
    'notifications',
    'settings',
    'messaging',

    'inviteSeller',
    'inviteBuyerAgent',
  ],

  getRegistrationScheme(sale, t) {
    let scheme = parentConfig.getRegistrationScheme.call(this, sale, t);

    scheme.email.headers.push('E-Mail Firma');

    scheme.phone.headers = [].concat(scheme.phone.headers, [
      'Telefon',
      'Telefon (privat)',
      'Telefon (geschäftlich)',
      'Mobiltelefon',
      'Telefon Firma',
      'Telefon (privat) Firma',
      'Telefon (geschäftlich) Firma',
      'Mobiltelefon Firma',
    ]);

    scheme.salutation.headers.push('Anrede Firma');
    scheme.firstName.headers.push('Vorname Firma');
    scheme.lastName.headers.push('Nachname Firma');
    scheme.title.headers.push('Titel Firma');

    scheme = Object.assign(scheme, {
      street: {
        title: t('Street'),
        type: 'textfield',
        target: 'buyerData.buyer_street',
        headers: [t('Street'), 'street', 'Straße', 'Straße Firma'],
        additional: true,
      },
      street_additional: {
        title: t('House number'),
        type: 'textfield',
        target: 'buyerData.buyer_street_additional',
        headers: [
          t('House number'),
          'house number',
          'Hausnummer',
          'Hausnummer Firma',
        ],
        additional: true,
      },
      zip: {
        title: t('ZIP code'),
        type: 'textfield',
        target: 'buyerData.buyer_zip',
        headers: [t('ZIP code'), t('Postal code'), 'zip', 'PLZ', 'PLZ Firma'],
        additional: true,
      },
      city: {
        title: t('City'),
        type: 'textfield',
        target: 'buyerData.buyer_city',
        headers: [t('City'), 'city', 'Stadt', 'Stadt Firma'],
        additional: true,
      },
      country_code: {
        title: t('Country'),
        type: 'textfield',
        target: 'buyerData.buyer_country_code',
        headers: [t('Country'), 'country', 'Land', 'Land Firma'],
        import: (value, item, data) => (value === 'D' ? 'DE' : value),
      },
      country: {
        title: t('Country'),
        type: 'textfield',
        target: 'buyerData.buyer_country',
        additional: true,
        import: (value, item, data) =>
          item['country_code'] === 'DE' ? 'Deutschland' : item['country_code'],
      },
      citizenship_code: {
        title: t('Citizenship'),
        type: 'textfield',
        target: 'buyerData.buyer_citizenship_code',
        additional: true,
        import: (value, item, data) => 'DE',
      },
      citizenship: {
        title: t('Citizenship'),
        type: 'textfield',
        target: 'buyerData.buyer_citizenship',
        additional: true,
        import: (value, item, data) => 'Deutschland',
      },
      dob: {
        title: t('Date of birth'),
        type: 'textfield',
        target: 'buyerData.buyer_dob',
        headers: [t('Date of birth'), 'birth date', 'Geburtstag', 'dob'],
        additional: true,
      },
      pob: {
        title: t('Place of birth'),
        type: 'textfield',
        target: 'buyerData.buyer_pob',
        headers: [t('Place of birth'), 'birth place', 'Geburtsort', 'pob'],
        additional: true,
      },
      company: {
        title: t('Company'),
        type: 'textfield',
        target: 'buyerData.buyer_company_name',
        headers: [t('Company'), t('Company name'), 'company', 'Firma'],
        additional: true,
      },
      buyer_type: {
        type: 'textfield',
        target: 'buyerData.buyer_type',
        transform: (value, item) => (!!item.company ? 'company' : 'private'),
        additional: true,
      },
      other_email: {
        title: t('Email'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_email',
        headers: ['E-Mail Partner', 'Mobiltelefon Partner'],
        additional: true,
      },
      other_phone: {
        title: t('Phone number'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_phone',
        headers: ['Telefon (privat) Partner'],
        additional: true,
      },
      other_salutation: {
        title: t('Salutation'),
        type: 'textfield',
        options: this.salutationTypes,
        localizationPrefixOverride: 'salutation',
        target: 'buyerData.others[0].buyer_salutation',
        headers: ['Anrede Partner'],
        additional: true,
      },
      other_title: {
        title: t('Title'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_title',
        headers: ['Titel Partner'],
        additional: true,
      },
      other_firstName: {
        title: t('First name'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_firstName',
        headers: ['Vorname Partner'],
        additional: true,
      },
      other_lastName: {
        title: t('Last name'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_lastName',
        headers: ['Nachname Partner'],
        additional: true,
      },
      other_street: {
        title: t('Street'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_street',
        headers: ['Straße Partner'],
        additional: true,
      },
      other_street_additional: {
        title: t('House number'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_street_additional',
        headers: ['Hausnummer Partner'],
        additional: true,
      },
      other_zip: {
        title: t('ZIP code'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_zip',
        headers: ['PLZ Partner'],
        additional: true,
      },
      other_city: {
        title: t('City'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_city',
        headers: ['Stadt Partner'],
        additional: true,
      },
      other_country_code: {
        title: t('Country code'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_country_code',
        headers: ['Land Partner'],
        additional: true,
        import: (value, item, data) => (value === 'D' ? 'DE' : value),
      },
      other_country: {
        title: t('Country'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_country',
        additional: true,
        import: (value, item, data) =>
          item['other_country_code'] === 'DE'
            ? 'Deutschland'
            : item['other_country_code'],
      },
      other_buyer_citizenship_code: {
        title: t('Citizenship code'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_citizenship_code',
        additional: true,
        transform: (value, item) => {
          return !!item.other_email ? 'DE' : null;
        },
      },
      other_buyer_citizenship: {
        title: t('Citizenship'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_citizenship',
        additional: true,
        transform: (value, item) => {
          return !!item.other_email ? 'Deutschland' : null;
        },
      },
      other_dob: {
        title: t('Date of birth'),
        type: 'textfield',
        target: 'buyerData.others[0].buyer_dob',
        headers: ['Geburtstag Partner'],
        additional: true,
      },
    });
    return scheme;
  },

  createOffer(sale, round, withBuyerData = true) {
    let offer = parentConfig.createOffer.call(this, sale, round, withBuyerData);
    if (!!sale.offerData.sale_country) {
      const buyerData = withBuyerData
        ? getCountryData(this, sale.offerData.sale_country)
        : {};
      offer = _.merge(offer, {
        offerData: {
          sale_country: sale.offerData.sale_country,
        },
        buyerData: buyerData,
      });
    }

    return offer;
  },
};

function getCountryData(config, sale_country) {
  const localizationData = {
    de: dataDe,
    en: dataEn,
    fi: dataFi,
    sl: dataSl,
    es: dataEs,
    ro: dataRo,
    fr: dataFr,
  };

  const [locale] = config.localeCodes[0].split('-');

  const countries = localizedCountries(localizationData[locale] || dataDe);

  const countryCode = sale_country.toUpperCase();
  const country = countries.get(countryCode);

  const hasCitizenship = ['de', 'ch', 'at', 'fi', 'gb', 'ro', 'si'].includes(
    sale_country
  );

  return {
    buyer_citizenship: hasCitizenship ? country : undefined,
    buyer_citizenship_code: hasCitizenship ? countryCode : undefined,
    buyer_country: country,
    buyer_country_code: countryCode,
  };
}



// WEBPACK FOOTER //
// ./src/app/@propnow/config.js